"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RUNNER_LOST_ERROR = void 0;
/**
 * Stable code of a run whose runner disappeared before its result could be
 * read; UI translates it using the viewer's language.
 */
exports.RUNNER_LOST_ERROR = 'AUTOMATION_RUNNER_LOST';
